import { Link as RouterLink, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isProductRoute } from 'utils/helpers';

import { MenuItem } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';

import { organizationSelectors } from 'store/selectors/organizations';

import { DropdownButton, NavigationDropdown } from '../NavigationDropdowns.styles';

const CampaignsDropdown = ({ organizationUuid }) => {
  const { location } = useHistory();

  const {
    organization: { flags },
  } = useSelector(state => ({
    organization: organizationSelectors.getOrganization(state),
  }));

  return (
    <NavigationDropdown
      name="Advocacy"
      isactualroute={isProductRoute(location, 'advocacy')}
      disabled={!flags?.showCampaigns}
      color="inherit"
      startIcon={null}
      endIcon={<KeyboardArrowDownIcon />}
      variant="text"
    >
      {handleSettingsClose => (
        <>
          <DropdownButton component={RouterLink} to={`/${organizationUuid}/campaigns`}>
            <MenuItem onClick={handleSettingsClose}>Campaigns</MenuItem>
          </DropdownButton>
          <DropdownButton component={RouterLink} to={`/${organizationUuid}/target-groups`}>
            <MenuItem onClick={handleSettingsClose}>Target Groups</MenuItem>
          </DropdownButton>
          {flags?.showCustomTargets && (
            <DropdownButton component={RouterLink} to={`/${organizationUuid}/custom-targets`}>
              <MenuItem onClick={handleSettingsClose}>Custom Targets</MenuItem>
            </DropdownButton>
          )}
          <DropdownButton
            component={RouterLink}
            disabled={!flags?.showActionAlerts}
            to={`/${organizationUuid}/templates/action_alert`}
          >
            <MenuItem onClick={handleSettingsClose}>Email Templates</MenuItem>
          </DropdownButton>
          <DropdownButton component={RouterLink} to={`/${organizationUuid}/campaigns/reports`}>
            <MenuItem onClick={handleSettingsClose}>Reports</MenuItem>
          </DropdownButton>
          <DropdownButton component={RouterLink} to={`/${organizationUuid}/campaigns/widgets`}>
            <MenuItem onClick={handleSettingsClose}>Widgets</MenuItem>
          </DropdownButton>
          {/* <DropdownButton */}
          {/*   component={RouterLink} */}
          {/*   to={`/${organizationUuid}/custom-targets`} */}
          {/* > */}
          {/*   <MenuItem onClick={handleSettingsClose}>Custom Targets</MenuItem> */}
          {/* </DropdownButton> */}
        </>
      )}
    </NavigationDropdown>
  );
};

CampaignsDropdown.propTypes = {
  organizationUuid: PropTypes.string.isRequired,
};

export default CampaignsDropdown;
